const SPOTIFY_PLAYLIST_PATH_REGEX = /^\/playlist\/([^/?#]+)\/?$/i;

export function extractSpotifyPlaylistId(url) {
    if (typeof url !== "string") {
        return null;
    }

    const trimmedUrl = url.trim();
    if (!trimmedUrl) {
        return null;
    }

    let parsedUrl;
    try {
        parsedUrl = new URL(trimmedUrl);
    } catch {
        return null;
    }

    if (parsedUrl.hostname.toLowerCase() !== "open.spotify.com") {
        return null;
    }

    const match = parsedUrl.pathname.match(SPOTIFY_PLAYLIST_PATH_REGEX);
    return match ? match[1] : null;
}
